import * as React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { Glosa, SolicitudAdminGlosa } from "../modelo/AdminGlosas";
import { ProcesoAdmin } from "../../config_general/modelo/ProcesoAdmin";
import { gestionarGlosaSAT } from "../modulos/adminGlosaActions";
import { ModalGestionarGlosa } from "./ModalGestionarGlosa";
import AccionAdministracion from "../../config_general/componentes/AccionAdministracion";
import { IconoAccion } from "../../config_general/modelo/IconoAccion";

class ModalAdminGlosa extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            showModalCrear: false,
            showModalActualizar: false
        };

    }

    render() {
        return (
            <div>
                <button type="button" className="btns btns-glyphicon" onClick={this.mostrarModalCrear}
                    disabled={this.state.showModalCrear}>
                    <AccionAdministracion texto="Crear" icono={IconoAccion.CREAR} />
                </button>
                <button type="button" className="btns btns-glyphicon" onClick={this.mostrarModalActualizar}
                    disabled={this.state.showModalActualizar}>
                    <AccionAdministracion texto="Editar" icono={IconoAccion.EDITAR} />
                </button>
                {this.crearGlosa()}
                {this.actualizarGlosa()}
            </div >
        );
    }

    crearGlosa = () => {
        return (
            <ModalGestionarGlosa
                titulo={"Crear Glosa"}
                esCrear
                consecutivo={this.props.consecutivo}
                servicio={undefined}
                codigoGlosa={undefined}
                validacion={this.props.validacion}
                mensajeUsuario={this.props.mensajeUsuario}
                tipoGestion={this.props.tipoGestion}
                descripcion={this.props.descripcion}
                fechaAlta={undefined}
                fechaBaja={this.props.fechaBaja}
                dniIngreso={this.props.dniIngreso}
                fechaIngresa={this.props.fechaIngresa}
                esBloqueante={this.props.esBloqueante}
                show={this.state.showModalCrear}
                onAceptar={this.crear}
                onCancelar={this.cerrarModalCrear} />

        );
    }

    actualizarGlosa = () => {
        return (
            <ModalGestionarGlosa
                titulo={"Actualizar Glosa"}
                esCrear={false}
                consecutivo={this.props.consecutivo}
                servicio={this.buscarServicio(this.props.consecutivoServicio)}
                codigoGlosa={this.props.codigoGlosa}
                validacion={this.props.validacion}
                mensajeUsuario={this.props.mensajeUsuario}
                tipoGestion={this.props.tipoGestion}
                descripcion={this.props.descripcion}
                fechaAlta={this.props.fechaAlta}
                fechaBaja={this.props.fechaBaja}
                dniIngreso={this.props.dniIngreso}
                fechaIngresa={this.props.fechaIngresa}
                esBloqueante={this.props.esBloqueante}
                show={this.state.showModalActualizar}
                onAceptar={this.actualizar}
                onCancelar={this.cerrarModalActualizar} />

        );
    }

    actualizar = (glosa: Glosa) => {
        const solicitud: SolicitudAdminGlosa = {
            dniModifica: this.props.dniUsuarioGestionLogin,
            datos: glosa,
            tipoProceso: ProcesoAdmin[1].codigo
        };

        this.cerrarModalActualizar();
        this.props.dispatch(gestionarGlosaSAT(solicitud));
    };

    crear = (glosa: Glosa) => {
        const solicitud: SolicitudAdminGlosa = {
            dniModifica: this.props.dniUsuarioGestionLogin,
            datos: glosa,
            tipoProceso: ProcesoAdmin[0].codigo
        };

        this.cerrarModalCrear();
        this.props.dispatch(gestionarGlosaSAT(solicitud));
    };

    cerrarModalActualizar = () => {
        this.setState({ showModalActualizar: false });
    };

    mostrarModalActualizar = () => {
        this.setState({ showModalActualizar: true });
    };

    cerrarModalCrear = () => {
        this.setState({ showModalCrear: false });
    };

    mostrarModalCrear = () => {
        this.setState({ showModalCrear: true });
    };

    buscarServicio = (codigo: number) => {
        const servicios = this.props.transaccionesSat;
        return servicios.find(servicio => servicio.codigo === codigo);
    }
}

export default connect((store: any, props: any) => {
    return {
        ...props,
        dniUsuarioGestionLogin: R.pathOr(undefined, ["inicio", "dniLogin"])(store),
        transaccionesSat: R.pathOr([], ["maestros", "transaccionesSat"])(store)
    };
})(ModalAdminGlosa);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_glosas/componentes/ModalAdminGlosa.tsx